import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import saludo from "../images/saludo.png";
import "../hojas-de-estilo/ModalBs.css"


function ModalBs({ show, handleClose, handleShow }) {

  return (
    <>
      <Modal 
        show={show}
        handleShow={handleShow}
        onHide={handleClose}
        className="modal" >

        <Modal.Header closeButton>
          <Modal.Title>Congratulations!</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className='modal-body'>
          I will not let you click 20 times, I don't want to bother you, 5 are enough :D
         <img src={saludo} className="saludo" /> 
        </Modal.Body>

        <Modal.Footer 
          id='modal-footer'>
          <Button 
            variant="primary"
            onClick={handleClose}
            id="buton-close" >
            Close
          </Button>
        </Modal.Footer>

      </Modal>
    </>
  );
}

export default ModalBs;
